import { useState } from 'react';
import { PathsViewUser } from 'components/paths';

interface Props {
  spacing: number;
}

const HomeActivePaths = ({ spacing }: Props) => {
  const [noData, setNoData] = useState(false);

  return (
    <div {...(!noData ? { style: { marginTop: spacing } } : {})}>
      <PathsViewUser
        hideIfNoData={true}
        isHomeView={true}
        limitPerPage={2}
        onNoData={(hasNoData) => setNoData(!hasNoData)}
        showAllLinkHref="/paths?type=active"
        titleShowCount={false}
      />
    </div>
  );
};

export default HomeActivePaths;
